import type { ReactNode } from 'react'
import { PaneBody } from '@/features/jobs/details/components/JobSections/Pane'
import styles from './ActivityPane.module.css'

export interface ActivityPaneProps {
  children: ReactNode
}

export function ActivityPane({ children }: ActivityPaneProps) {
  return (
    <PaneBody>
      <div className={styles.list} data-test="events-new">
        {children}
      </div>
    </PaneBody>
  )
}
